import { Link } from "react-router-dom";

export const messages = [
    {
        id: 1,
        contact: "(405) 541 234",
        date: "01/12/2023",
        time: "11:23 pm",
        message: "Hello",
        userType: "",
        messageType: "sent",
        senderName: "John",
        recieverName: "Aamir"
    },
    {
        id: 2,
        contact: "(405) 541 234",
        date: "01/12/2023",
        time: "11:23 pm",
        message: "I was interested in making looking at this property for rent. If possible, I would like to see make an appointment to see the property",
        userType: "Vendor",
        messageType: "recieved",
        senderName: "John",
        recieverName: "Aamir"
    },
    {
        id: 3,
        contact: "(405) 541 234",
        date: "01/12/2023",
        time: "11:23 pm",
        message: "Hello world",
        userType: "",
        messageType: "recieved",
        senderName: "John",
        recieverName: "Aamir"
    },
];

export const messageTabs = [
    {
      key: '1',
      label: <Link to="?filter_type=all">All</Link>,
    },
    {
      key: '2',
      label: <Link to="?filter_type=unread">Unread</Link>,
    },
  ];

